import { useEffect, useState } from "react";
import { Box, Typography, Card, CardContent, Avatar, Button } from "@mui/material";
import { getBlockedChannels, unblockChannel } from "../../services/APIServices/block.api";
import { useTranslation } from "react-i18next";

export default function BlockedChannels() {
     const [channels, setChannels] = useState<any[]>([]);
     const [loading, setLoading] = useState(true);
     const { t } = useTranslation();

     useEffect(() => {
          fetchChannels();
     }, []);

     const fetchChannels = async () => {
          try {
               const res = await getBlockedChannels();
               setChannels(res as any || []);
          } catch (err) {
               console.error(err);
          } finally {
               setLoading(false);
          }
     };

     const handleUnblock = async (id: string) => {
          try {
               await unblockChannel(id);
               setChannels((prevChannels) => prevChannels.filter((c) => c.blockedID !== id));
          } catch (err) {
               console.error(err);
          }
     };

     if (loading) return <Typography>Loading...</Typography>;

     if (channels.length === 0) {
          return (
               <Box sx={{ textAlign: "center", mt: 4 }}>
                    <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                         {t("blocked.blockedChannels")}
                    </Typography>
                    <Typography variant="h6">{t("blocked.blockedChannelsNone")}</Typography>
               </Box>
          );
     }

     return (
          <Box sx={{ p: 2 }}>
               <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                    {t("blocked.blockedChannels")}
               </Typography>

               {channels.map(channel => (
                    <Card
                         key={channel.blockedID}
                         sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 2,
                              borderRadius: 3,
                              p: 1,
                         }}
                    >
                         <Avatar src={channel.logoUrl} sx={{ width: 56, height: 56, mr: 2 }} />
                         <CardContent sx={{ flexGrow: 1 }}>
                              <Typography variant="body1" fontWeight={500} noWrap
                                   sx={{
                                        maxWidth: {
                                             xs: "140px",
                                             sm: "200px",
                                             md: "250px",
                                        },
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                   }}>
                                   {channel.name}
                              </Typography>
                         </CardContent>
                         <Button
                              variant="contained"
                              color="warning"
                              sx={{ borderRadius: 5 }}
                              onClick={() => handleUnblock(channel.blockedID)}
                         >
                              {t("blocked.unblock")}
                         </Button>
                    </Card>
               ))}
          </Box>
     );
}
